<template>
  <b-container fluid>
    <b-row>
      <b-col sm="12">
        <iq-card>
          <template v-slot:headerTitle>
            <div class="d-flex justify-content-center align-items-center"><h4 class="card-title mr-2">Lịch sử hoạt động</h4>  <span class="mt-1 text-secondary">Giúp bạn kiểm soát tất cả hoạt động</span></div>
          </template>
          <template v-slot:body>
            <div class="table-responsive">
              <b-table
                id="user-list-table"
                ref="userListTableRef"
                :items="activityList"
                :fields="fields"
                :striped="false"
                :outlined="true"
                :small="true"
                :hover="true"
                :busy.sync="isBusy"
                :primary-key="'id'"
                :no-local-sorting="true"
                class="table-striped table-bordered mt-1"
                role="grid"
                aria-describedby="user-list-page-info"
                show-empty
              >
                <template v-slot:cell(action_name)="data">
                  <span v-html="data.value"/>
                </template>
                <template #empty="scope">
                  <p class="text-center">Chưa có dữ liệu</p>
                </template>
                <template #emptyfiltered="scope">
                  <p class="text-center">Không tìm thấy dữ liệu</p>
                </template>
              </b-table>
            </div>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { findash } from '../../config/pluginInit'
import api from '@/store/api'

export default {
  name: 'UserActivityLog',
  async mounted () {
    findash.index()
    this.activityList = await this.loadPage()
  },
  data () {
    return {
      currentPage: 1,
      totalRows: 1000, // need to get this from server side
      perPage: 100, //
      localItemsPerPage: 0, // if you want use SSR
      isBusy: false,
      fields: [
        {
          key: 'created_at',
          label: 'Thời gian',
          thStyle: { width: '20%' },
          class: 'text-center'
        },
        {
          key: 'action_name',
          thStyle: { width: '25%' },
          label: 'Thao tác'
        },
        {
          key: 'user_agent',
          label: 'Thiết bị'
        }
      ],
      activityList: []
    }
  },
  computed: {
  },
  methods: {
    loadPage () {
      this.isBusy = true
      let promise = api.user_activity.list()

      return promise.then((response) => {
        const items = response
        this.isBusy = false
        return (items)
      }).catch(() => {
        this.isBusy = false
        return []
      })
    }
  }
}
</script>
